export class Organization {
  static ORGANIZATION_OWNER: string = "Organization Owner";
}
